/**
 * Fetcher for a polled Solid resource. Once a value is on screen, a failed refresh keeps it instead
 * of rejecting: reading an errored resource throws inside effects and timers, which silently stops
 * the polling (the trip recap stayed on "calcul…" after one lost request on a phone).
 * The first load, and a load for a new source, still reject: there is nothing valid to keep.
 */
export function keepOnFailedRefresh<S, T>(
  load: (source: S) => Promise<T>,
  onFailure?: (failed: boolean) => void,
) {
  return async (source: S, info: { value: T | undefined; refetching: unknown }): Promise<T> => {
    try {
      const value = await load(source);
      onFailure?.(false);
      return value;
    } catch (e) {
      onFailure?.(true);
      if (info.refetching && info.value !== undefined) return info.value;
      throw e;
    }
  };
}
